export const reportLocationsEnum = [
  {
    label: 'Uživatelské klasifikace (události) přehled',
    id: 'eventClassificationOverview'
  },
  {
    label: 'Uživatelská klasifikace (události) detail',
    id: 'eventClassificationDetail'
  },
  {
    label: 'Události přehled',
    id: 'eventOverview'
  },
  {
    label: 'Událost detail',
    id: 'eventDetail'
  },
  {
    label: 'Způsoby oznámení (události) přehled',
    id: 'eventReportTypeOverview'
  },
  {
    label: 'Způsob oznámení (události) detail',
    id: 'eventReportTypeDetail'
  },
  {
    label: 'Způsoby řešení (události) přehled',
    id: 'eventResolutionOverview'
  },
  {
    label: 'Způsob řešení (události) detail',
    id: 'eventResolutionDetail'
  },
  {
    label: 'Typy (události) přehled',
    id: 'eventTypeOverview'
  },
  {
    label: 'Typ (události) detail',
    id: 'eventTypeDetail'
  },
  {
    label: 'Záznam o odevzdaných blocích',
    id: 'ticketPaymentRecord'
  },
  {
    label: 'Přestupky přehled',
    id: 'delictOverview'
  },
  {
    label: 'Přestupek detail',
    id: 'delictDetail'
  },
  {
    label: 'Způsoby zjištění (přestupku) přehled',
    id: 'discoveryOverview'
  },
  {
    label: 'Způsob zjištění (přestupku) detail',
    id: 'discoveryDetail'
  },
  {
    label: 'Bloky přehled',
    id: 'ticketOverview'
  },
  {
    label: 'Blok detail',
    id: 'ticketDetail'
  },
  {
    label: 'Typy (přestupků) přehled',
    id: 'delictTypeOverview'
  },
  {
    label: 'Typ (přestupku) detail',
    id: 'delictTypeDetail'
  },
  {
    label: 'Hledané osoby přehled',
    id: 'wantedPersonOverview'
  },
  {
    label: 'Hledaná osoba detail',
    id: 'wantedPersonDetail'
  },
  {
    label: 'Typy (osvědčení) přehled',
    id: 'certificateTypeOverview'
  },
  {
    label: 'Typ (osvědčení) detail',
    id: 'certificateTypeDetail'
  },
  {
    label: 'Vzdělání přehled',
    id: 'educationOverview'
  },
  {
    label: 'Vzdělání detail',
    id: 'educationDetail'
  },
  {
    label: 'Zaměstnanci přehled',
    id: 'employeeOverview'
  },
  {
    label: 'Zaměstnanec detail',
    id: 'employeeDetail'
  },
  {
    label: 'Pracovní pozice přehled',
    id: 'workPositionOverview'
  },
  {
    label: 'Pracovní pozice detail',
    id: 'workPositionDetail'
  },
  {
    label: 'Volací znaky přehled',
    id: 'callSignOverview'
  },
  {
    label: 'Volací znak detail',
    id: 'callSignDetail'
  },
  {
    label: 'Jízdy přehled',
    id: 'tripOverview'
  },
  {
    label: 'Jízda detail',
    id: 'tripDetail'
  },
  {
    label: 'Služební vozidla přehled',
    id: 'vehicleOverview'
  },
  {
    label: 'Služební vozidlo detail',
    id: 'vehicleDetail'
  },
  {
    label: 'Opravy přehled',
    id: 'repairOverview'
  },
  {
    label: 'Oprava detail',
    id: 'repairDetail'
  },
  {
    label: 'Hledané vozidla přehled',
    id: 'wantedVehicleOverview'
  },
  {
    label: 'Hledané vozidlo detail',
    id: 'wantedVehicleDetail'
  },
  {
    label: 'Skladové karty přehled',
    id: 'inventoryCardOverview'
  },
  {
    label: 'Skladová karta detail',
    id: 'inventoryCardDetail'
  },
  {
    label: 'Skladové doklady přehled',
    id: 'protocolOverview'
  },
  {
    label: 'Skladový doklad likvidační detail',
    id: 'disposalProtocolDetail'
  },
  {
    label: 'Skladový doklad výdejka detail',
    id: 'issueProtocolDetail'
  },
  {
    label: 'Skladový doklad dodejka detail',
    id: 'procurementProtocolDetail'
  },
  {
    label: 'Skladový doklad převodka detail',
    id: 'transferProtocolDetail'
  },
  {
    label: 'Skladový doklad příjemka detail',
    id: 'receiptProtocolDetail'
  },
  {
    label: 'Dodavatelé přehled',
    id: 'supplierOverview'
  },
  {
    label: 'Dodavatel detail',
    id: 'supplierDetail'
  },
  {
    label: 'Sklady přehled',
    id: 'warehouseOverview'
  },
  {
    label: 'Sklad detail',
    id: 'warehouseDetail'
  },
  {
    label: 'Hledané doklady přehled',
    id: 'wantedIdentificationOverview'
  },
  {
    label: 'Hledaný doklad detail',
    id: 'wantedIdentificationDetail'
  },
  {
    label: 'Barvy (psa) přehled',
    id: 'dogColorOverview'
  },
  {
    label: 'Barva psa detail',
    id: 'dogColorDetail'
  },
  {
    label: 'Plemena (psů) přehled',
    id: 'dogBreedOverview'
  },
  {
    label: 'Plemeno psa detail',
    id: 'dogBreedDetail'
  },
  {
    label: 'Psi přehled',
    id: 'dogOverview'
  },
  {
    label: 'Pes detail',
    id: 'dogDetail'
  }
];

export const reportProvidersEnum = [
  {
    id: 'cz.inqool.uas.metropolis.ed.ticket.report.TicketPaymentRecordProvider',
    label: 'Report o platbě bloku'
  },
  {
    id: 'cz.inqool.uas.metropolis.cl.trip.report.CcsOverviewProvider',
    label: 'CCS přehled'
  },
  {
    id: 'cz.inqool.uas.metropolis.wa.protocol.report.InventoryProtocolProvider',
    label: 'Inventář skladových dokladů'
  },
  {
    id: 'cz.inqool.uas.metropolis.wa.protocol.report.InventoryEmployeeProvider',
    label: 'Inventář zaměstnanců'
  },
  {
    id: 'cz.inqool.uas.metropolis.wa.protocol.report.InventoryListProvider',
    label: 'Inventář seznamů'
  },
  {
    id: 'cz.inqool.uas.metropolis.wa.protocol.report.InventorySummaryProvider',
    label: 'Inventář souhrnů'
  },
  {
    id: 'cz.inqool.uas.dictionary.report.ValueAdapterProvider',
    label: 'Adaptér hodnot'
  },
  {
    id: 'cz.inqool.uas.report.provider.ScriptProvider',
    label: 'Skript'
  },
  {
    id: 'cz.inqool.uas.report.provider.DataAdapterProvider',
    label: 'Adaptér dat'
  },
  {
    id: 'cz.inqool.uas.report.provider.SqlProvider',
    label: 'SQL'
  },
  {
    id: 'cz.inqool.uas.report.provider.PassthroughProvider',
    label: 'Přesměrovací poskytovatel'
  },
  {
    id: 'cz.inqool.uas.metropolis.hr.employee.report.EmployeeProvider',
    label: 'Zaměstnanci'
  }
];



// WEBPACK FOOTER //
// ./src/modules/reports/_reportsEnums.ts